import { Component, Input, ChangeDetectorRef } from '@angular/core';

import { CommonService } from '@app/services/common.service';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'log_box_relay',
    templateUrl: './relay.component.html',
    styleUrls: ['../../../common.scss', '../../c_card_event_viewer_time_line.component.scss'],
    standalone: false
})
export class log_box_relay_component extends BaseComponent {
  @Input() log;
  @Input() timezone;

  constructor(
    public commonService: CommonService,
  ) { super(); }

  // -------------------------------------------------------
  // COMMON
  isAutomationRule(log){
    const description = log.description.toLowerCase()
    const isAutomationRule = description.includes('automation')
    return isAutomationRule || this.log.isAutomation
  }

  // --------------------------------------------------------------
  // STYLE
  relayIcon(meta){
    if(!meta || typeof meta != 'string') return 'relay'
    const metaData = JSON.parse(meta)
    const iconName = metaData?.info?.relay?.icon ?? 'relay'
    return iconName
  }
  capitalizeFirstLetter(string: string) {
    if(!string || typeof string != 'string') return
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
